export class LanguageGroupItem {
  idLanguageGroupItem: number;
  idLanguageGroup: number;
  code: string;
  orphan: boolean;

  constructor(
    idLanguageGroupItem: number,
    idLanguageGroup: number,
    code: string,
    orphan: boolean,
  ) {
    this.idLanguageGroupItem = idLanguageGroupItem;
    this.idLanguageGroup = idLanguageGroup;
    this.code = code;
    this.orphan = orphan;
  }

  static fromRaw(raw: any): LanguageGroupItem {
    return new LanguageGroupItem(
      Number(raw.idLanguageGroupItem),
      Number(raw.idLanguageGroup),
      String(raw.code),
      Boolean(raw.orphan),
    );
  }

  clone(): LanguageGroupItem {
    return new LanguageGroupItem(
      this.idLanguageGroupItem,
      this.idLanguageGroup,
      this.code,
      this.orphan,
    );
  }

  toPayload(): any {
    return {
      idLanguageGroupItem: this.idLanguageGroupItem,
      idLanguageGroup: this.idLanguageGroup,
      code: this.code,
      orphan: this.orphan,
    };
  }
}
